import { render } from "./RegisterModalEC.vue?vue&type=template&id=ab7ac014"
import script from "./RegisterModalEC.vue?vue&type=script&lang=ts"
export * from "./RegisterModalEC.vue?vue&type=script&lang=ts"
script.render = render

export default script